import {HTTP} from "../http";

export default {
    namespaced: true,

    state: {
        loading: false,
        cart: []
    },

    mutations: {
        setLoading(state, loading) {
            state.loading = loading;
        },

        set(state, cart) {
            state.cart = cart;
        }
    },

    actions: {
        add({commit}, {id, quantity}) {
            commit('setLoading', true);

            return HTTP.post('/cart/add/' + id + '?quantity=' + quantity)
                .then(resp => commit('set', resp.data))
                .then(() => commit('setLoading', false))
                .catch(err => commit('error/set', err, {root: true}));
        },

        remove({commit}, id) {
            commit('setLoading', true);

            return HTTP.post('/cart/remove/' + id)
                .then(resp => commit('set', resp.data))
                .then(() => commit('setLoading', false))
                .catch(err => commit('error/set', err, {root: true}));
        },

        load({commit}) {
            commit('setLoading', true);

            return HTTP.get('/cart/')
                .then(resp => commit('set', resp.data))
                .then(() => commit('setLoading', false))
                .catch(err => commit('error/set', err, {root: true}));
        }
    }
}


// WEBPACK FOOTER //
// ./src/store/cart.js